import {
  buttonText,
  contentSetting,
  title,
} from '@/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page-revamp/constant';
import { isEqual } from 'lodash';

const fields = [
  [buttonText, buttonText],
  [contentSetting, title],
];

export default (
  changeFields: Array<any>,
  { pcForm, tabletForm, mobileForm },
) => {
  changeFields.map((field) => {
    const name = field?.name;
    const value = field?.value;
    if (fields.findIndex((v) => isEqual(name, v)) !== -1) {
      tabletForm.setFields([{ name, value }]);
      mobileForm.setFields([{ name, value }]);
    }
  });
};
